<template>
  <div id="headwrapper" ref="headerWrapper">
  <div id="header8" :class="{ widest: widetoggle, scrolled: scrolled }">
      <div id="logo">
        <router-link to="/" v-if="account && account.logo_url" >
          <img style="border-radius: 1px;" :src="'https://corl8-files.s3.amazonaws.com/' + account.logo_url" :title="account.account_name" alt="Home">
        </router-link>
        <router-link to="/" v-else-if="account && account.account_name">
          <div style="font-size:18px;">{{ account.account_name | truncate(15, '...') }}</div>
        </router-link>
        <router-link to="/" v-else>
          <img :src="require('@/assets/foclarity-logo-white-sm.png')" alt="Foclarity" />
        </router-link>
      </div>
      <div id="center-nav">
        <div id="regularnav">
          <div class="navlinks">
          <ul>
            <router-link class="implink" tag="li" v-if="isLoggedIn() && (account && (account.user_id === user.user_id) && account.consulting && user.consultant)" to="/clients">My Clients</router-link>
            <router-link class="implink" tag="li" v-if="isLoggedIn() && user && user.is_super_admin" to="/admin">Admin</router-link>
            <router-link class="implink" tag="li" v-if="isLoggedIn()" to="/profile">My Profile</router-link>
            <router-link class="implink" tag="li" v-if="isLoggedIn()" :to="{name: 'accounts', query: {r: '/dashboards'}}">Switch Accounts</router-link>
            <li class="implink" v-if="isLoggedIn()" @click.prevent="feedback = true;">Help</li>
            <router-link class="implink" tag="li" v-if="!isLoggedIn()" to="/platform">Solutions</router-link>
            <router-link class="implink" tag="li" v-if="!isLoggedIn()" to="/services">Services</router-link>
            <router-link class="implink" tag="li" v-if="!isLoggedIn()" to="/advising">Advising</router-link>
            <router-link class="implink" tag="li" v-if="!isLoggedIn()" to="/partners" v-show="false">Partners</router-link>
            <router-link class="implink" tag="li" to="/pricing" v-if="!isLoggedIn()" v-show="false">Pricing</router-link>
            <router-link class="implink" tag="li" to="/about" v-if="!isLoggedIn()">Company</router-link>
            <router-link class="implink" tag="li" to="/contact" v-show="false">Contact</router-link>
          </ul>
          </div>
        </div>
      </div>
      <div id="nav-actions">
        <div class="authlinks">
          <a v-if="!isLoggedIn()" href="/contact" style="text-transform: none;">Get a demo</a>
          <span v-if="!isLoggedIn()"> | </span>
          <router-link v-if="!isLoggedIn()" to="/login">Login</router-link>
          <a v-if="isLoggedIn()" href="#" @click.prevent="handleLogout()" class="logout-link">Logout</a>
        </div>
        <!-- mobile nav toggle button sits here; the menu itself is rendered as a sibling below so it can be full width -->
        <div id="mobilenav" class="menuicon" @click="toggle = !toggle">
          <div class="bar1" :class="{ change: toggle }"></div>
          <div class="bar2" :class="{ change: toggle }"></div>
          <div class="bar3" :class="{ change: toggle }"></div>
        </div>
      </div>
      <!-- move mobile nav out of the right actions container so it can span full width and not hide the logo -->
      <transition name="dropme">
        <div id="nav" :class="{ on: toggle }" v-if="toggle" style="box-shadow: #004466 0px 4px 1px;">
          <ul>
            <template v-if="!isLoggedIn()">
              <router-link tag="li" to="/">Home</router-link>
              <router-link tag="li" to="/platform">Solutions</router-link>
              <router-link tag="li" to="/services">Services</router-link>
              <router-link tag="li" to="/advising">Advising</router-link>
              <router-link tag="li" to="/partners" v-show="false">Partners</router-link>
              <router-link tag="li" to="/pricing" v-show="false" >Pricing</router-link>
              <router-link tag="li" to="/about">About Us</router-link>
              <router-link tag="li" to="/contact" style="border-bottom:2px solid #004466;" >Contact</router-link>
              <router-link tag="li" to="/login">Login</router-link>
              <router-link tag="li" :to="{ name: 'register', params: { r: 'r8jw934uHJnr' }}">Register</router-link>
            </template>
            <template v-if="isLoggedIn()">
              <router-link tag="li" to="/dashboards">Boards</router-link>
              <router-link tag="li" to="/dashboard" v-show="false">
                AI Assistant
                <img :src="require('@/assets/ic_sparkle.png')" width="20" height="20" alt="AI Chat" title="AI Chat" style="cursor:pointer;margin-left:4px;" />
              </router-link>
              <router-link tag="li" to="/mission">Mission</router-link>
              <router-link tag="li" to="/team">Team</router-link>
              <router-link tag="li" v-if="user && user.is_super_admin" to="/admin">Admin</router-link>
              <router-link tag="li" to="/profile">Profile</router-link>
              <li @click="showVideo = true" v-if="isLoggedIn()">Demo Video</li>
            </template>
            <template v-if="isLoggedIn() && (account.user_id === user.user_id)">
              <li style="height:2px;background:#004466;"></li>
              <router-link tag="li" v-if="isLoggedIn() && (account && (account.user_id === user.user_id))" :to="{name: 'scorecards', params: {account_id: account.account_id}, query: {r: 'dashboards'}}">New Board</router-link>
              <router-link tag="li" :to="{name: 'account', params: {account_id: account.account_id}, query: {r: '/dashboards'}}">Account</router-link>
            </template>
            <router-link tag="li" v-if="isLoggedIn() && (account && (account.user_id === user.user_id) && account.consulting == true && user.consultant)" to="/clients">Clients</router-link>
            <template v-if="isLoggedIn()">
              <router-link tag="li" to="/accounts" style="border-top:1px solid #004466;">Switch Account</router-link>
              <li @click.prevent="feedback = true;">Help</li>
              <li @click.prevent="handleLogout()" style="border-bottom:2px solid #004466;">Logout</li>
            </template>
          </ul>
        </div>
  </transition>
      <!-- use the modal component, pass in the prop -->
      <feedback v-if="feedback" @close="feedback = false"></feedback>


      <!-- use the modal component, pass in the prop -->
      <modal v-if="showVideo" @close="showVideo = false">
        <template v-slot:header>
          <h3>Foclarity Demo Video</h3>
        </template>
        <template v-slot:body>
          <iframe style="margin-top:10px;width: 100%; aspect-ratio: 16/9;" src="https://www.youtube.com/embed/Wi9PWCJ_2U0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>        
        </template>
        <template v-slot:footer>
          <p>Foclarity helps your team get focused.</p>
        </template>
      </modal>                

    </div>
  </div>
</template>

<script>
import { isLoggedIn, login, logout } from "../../utils/auth";
import { accountService, userService } from '../../_services';
import feedback from "@/components/includes/SendFeedback"
import modal from "@/components/includes/InfoModal"

export default {
  name: "app-nav",
  data() {
    return {
      toggle: false,
      user: "",
      account: "",
      feedback: false,
      fixytoggle: false,
      widetoggle: false,
      scrolled: false,
      search: "",
      showVideo: false
    };
  },
  created () {
    if (this.isLoggedIn()) {
      this.widetoggle = false ;
      this.account = accountService.getActiveAccount()
      userService.getMe().then(data => {
        this.user = data
      });
    }
    // window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    // make header fixed at top and reserve space so content doesn't jump
    this.makeHeaderFixed();
    window.addEventListener('resize', this.makeHeaderFixed);
    // add scroll listener to toggle translucent header
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.makeHeaderFixed);
    window.removeEventListener('scroll', this.onScroll);
    // cleanup any padding we added
    if (document && document.body) {
      document.body.style.paddingTop = '';
    }
  },
  destroyed () {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  components: {
    feedback,
    modal
  },
  methods: {
    onScroll() {
      // small threshold so tiny scrolls don't trigger it
      try {
        const y = window.scrollY || window.pageYOffset || 0;
        this.scrolled = y > 12;
      } catch (e) {
        // noop
      }
    },
    makeHeaderFixed() {
      try {
        const el = this.$refs.headerWrapper;
        if (!el) return;
        // ensure the wrapper is fixed and on top via CSS (scoped rules also set this)
        // reserve space so page content is not covered
        const h = el.offsetHeight || 80;
        if (document && document.body) document.body.style.paddingTop = h + 'px';
      } catch (e) {
        // noop
      }
    },
    handleLogin() {
      login();
    },
    handleLogout() {
      logout();
    },
    construction() {
      alert("This feature is under construction. Please check back soon.")
      this.search = ""
    },
    handleScroll () {
      // if (screen.width > 440) {
      //   if (window.scrollY > 40){
      //     this.fixytoggle = true
      //   } else {
      //     this.fixytoggle = false
      //   }
      // } else {
      //   if (window.scrollY > 0){
      //     this.fixytoggle = true
      //   } else {
      //     this.fixytoggle = false
      //   }
      // }
    },
    isLoggedIn() {
      return isLoggedIn();
    }    
  }
};
</script>

<style scoped lang="scss">
@import "../../scss/colors";
#headwrapper {
  height:80px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000;
}
#header8 {
  padding: 10px 15px 0px 15px;
  position: relative;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // max-width: 1170px;
  margin: 0 auto;
  // background-color: #ddeeff;
  // background: #edf6ff;
  // background: linear-gradient(180deg, #ffffff 0%, #edf6ff 80%);
  // background: linear-gradient(180deg, rgba(255,255,255,0.82) 0%, rgba(202, 226, 253, 0.82) 100%);
  background: #0a0828;
  // background: #000 ;
  // border-radius: 40px;
  // border: 1px solid #004466;
  border-bottom:1px solid #582ecc;
  text-align: left;
  & #logo {
    display: inline-block;
    font-size: 2em;
    // line-height: 1.5em;
    padding: 8px 0 4px 8px ;
    & > a {
      text-decoration: none;
      border-bottom: 0;
      color: #fff;
      & > img {
        height: 30px;
      }
    }
    @media only screen and (max-width: 440px) {
      padding-left: 8px;
    }
    @media only screen and (min-width: 1230px) {
      padding-left: 15px;
    }
  }
  // & a {
  //   font-weight: bold;
  //   // color: $color-main;
  //   color:#ccc;
  //   text-decoration: none;
  //   margin: 0;
  //   &.router-link-exact-active {
  //     color: darken($color-accent, 5%);
  //   }
  // }
  /* center container keeps nav centered */
  & #center-nav {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* right-side actions (login/signup/logout) */
  & #nav-actions {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    padding-left: 12px;
  }
  & #mobilenav {
    padding: 12px 8px 0 0;
    margin: 0;
  }
  & #nav {
    z-index: 20000;
    position: absolute;
    top: 65px;
    right: 0px;
    margin-top: 10px;
    width: 100%;
    display: none;
    border-top: 4px solid #582ecc;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
    & > ul {
      width: auto;
      padding: 0;
      margin: 0;
      & > li {
        display: block;
        text-align: left;
        text-transform: capitalize;
        cursor: pointer;
        margin: 0;
        padding: 0 10px;
        font-size: 16px;
        font-weight: 400;
        line-height: 2.5em;
        background: #fff;
        border-bottom: 1px solid #eee;
        color:#004466;
        //border-left: 4px solid #ddd ;
        //border-right: 4px solid #ddd ;
        &.router-link-exact-active {
          color: #333;
          //border-left: 4px solid $color-gray ;
          //border-right: 4px solid $color-gray ;
        }
        &:hover {
          background: #eee;
          //border-left: 4px solid $color-gray ;
          //border-right: 4px solid $color-accent ;
          //color: #fff ;
        }
      }
    }
    &.on {
      display: block;
    }
  }
  /* translucent state when user scrolls */
  &.scrolled {
    // background: rgba(0,0,0,0.80);
    background: #0a082892;
    box-shadow: 0 6px 14px rgba(0,0,0,0.08);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
  }

  /* smooth transition between states */
  transition: background 220ms ease, box-shadow 220ms ease;
  &.fixy {
    position: fixed;
    top:0;
    max-width: 100%;
    width: 100%;
    background: #efefef;
    z-index: 1000;
  }
  &.widest {
    max-width: 100% ;
  }
}
.dropme-enter-active,
.dropme-leave-active {
  transition: opacity 0.1s;
}

.dropme-enter, .dropme-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}

.btnHome {
  float: right;
  display: block;
  width:40px;
  text-align: center;
  margin: 0 0 0 20px;
  padding: 0 2px;
  color: #666;
  &.router-link-exact-active {
    display: none;
  }
}

/* desktop nav: show center nav on wide screens */
#regularnav {
  @media only screen and (max-width: 1060px) {
    display: none;
  }
  .navlinks {
    & > ul {
      display: flex;
      gap: 14px;
      align-items: center;
      width: auto;
      padding: 0;
      margin: 9px 0 0 0;
      & > li {
        list-style: none;
        display: inline-block;
        text-transform: capitalize;
        cursor: pointer;
        margin: 0;
        padding: 0 6px;
        font-size: 16px;
        font-weight: 400;
        line-height: 3.5em;
        color: #004466;
        &.implink {
          // color: #004466;
          color:#ccc;
          border-bottom: 4px solid transparent;
        }
        &.router-link-exact-active {
          // color: #004466;
          color:#ccc;
          border-bottom:4px solid #582ecc;
        }
        &:hover {
          // color: #004466;
          color:#ccc;
          border-bottom: 4px solid #ffaa00;
        }
      }
    }
  }
}

/* auth links on right */
.authlinks {
  display: flex;
  gap: 8px;
  align-items: center;
  color: #ccc;
  & > a {
    cursor: pointer;
    font-size: 16px;
    font-weight: 400 !important;
    line-height: 3em;
    padding-top:6px;
    color: #ccc;
    text-decoration: none;
    &:hover {
      color:#ffaa00;
    }
  }
  @media only screen and (max-width: 1060px) {
    display: none;
  }
}
.menuicon {
  display: inline-block;
  cursor: pointer;
  @media only screen and (min-width: 1061px) {
    display: none;
  }

  & > .bar1,
  .bar2,
  .bar3 {
    width: 35px;
    height: 4px;
    background-color: #676767;
    margin: 6px 0;
    transition: 0.4s;
  }

  & > .bar1 {
    &.change {
      -webkit-transform: rotate(-45deg) translate(-8px, 6px);
      transform: rotate(-45deg) translate(-8px, 6px);
      background-color: #004466;
    }
  }

  & .bar2 {
    &.change {
      opacity: 0;
    }
  }

  & .bar3 {
    &.change {
      -webkit-transform: rotate(45deg) translate(-8px, -6px);
      transform: rotate(45deg) translate(-8px, -6px);
      background-color: #004466;
    }
  }
}
</style>
